module.exports = __webpack_public_path__ + "static/bett1aces_locations_1080x1080_steffigrafstadion-sm-30d2321cde7e5c867244ee694e46e2fe.gif";